// Idioma por defecto de cada escuela — fuente única de verdad.
//
// CommonJS a propósito: este archivo lo consume `gatsby-config.js`, que es CJS y
// corre en Node antes del build, y también el código del browser vía import. Los
// demás archivos de `config/schools/` son ESM y `gatsby-config.js` no los puede
// requerir, así que el valor vivía duplicado (una constante en gatsby-config y un
// campo `defaultLanguage` en `efs.js` que no leía nadie). Acá deja de estarlo.
//
// El alumno de SFS es angloparlante aprendiendo español; el de EFS es
// hispanohablante aprendiendo inglés. Con `prefixDefault: false` en
// gatsby-plugin-react-i18next, el idioma por defecto va sin prefijo y el otro
// debajo del suyo:
//
//   SFS →  /  = EN,  /es/ = ES
//   EFS →  /  = ES,  /en/ = EN
//
// Ver project-log/initiatives/active/efs-idioma-por-defecto-espanol.md.

const DEFAULT_LANGUAGE_BY_SCHOOL = {
  sfs: 'en',
  efs: 'es',
};

const FALLBACK_LANGUAGE = 'en';

/** Idioma por defecto de una escuela. Cae a inglés si el id no se reconoce. */
function defaultLanguageFor(schoolId) {
  return DEFAULT_LANGUAGE_BY_SCHOOL[schoolId] || FALLBACK_LANGUAGE;
}

module.exports = {
  DEFAULT_LANGUAGE_BY_SCHOOL,
  FALLBACK_LANGUAGE,
  defaultLanguageFor,
};
